/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOverwolfGameImages
 */
export interface CreateOverwolfGameImages {
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    devourGameLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    bannerImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    bannerImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    landingImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    landingImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameImages
     */
    timeRewardImage?: string;
}

/**
 * Check if a given object implements the CreateOverwolfGameImages interface.
 */
export function instanceOfCreateOverwolfGameImages(value: object): value is CreateOverwolfGameImages {
    return true;
}

export function CreateOverwolfGameImagesFromJSON(json: any): CreateOverwolfGameImages {
    return CreateOverwolfGameImagesFromJSONTyped(json, false);
}

export function CreateOverwolfGameImagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOverwolfGameImages {
    if (json == null) {
        return json;
    }
    return {
        
        'logo': json['logo'] == null ? undefined : json['logo'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'devourGameLogo': json['devourGameLogo'] == null ? undefined : json['devourGameLogo'],
        'thumbnailImage': json['thumbnailImage'] == null ? undefined : json['thumbnailImage'],
        'bannerImageSmall': json['bannerImageSmall'] == null ? undefined : json['bannerImageSmall'],
        'bannerImageLarge': json['bannerImageLarge'] == null ? undefined : json['bannerImageLarge'],
        'landingImageSmall': json['landingImageSmall'] == null ? undefined : json['landingImageSmall'],
        'landingImageLarge': json['landingImageLarge'] == null ? undefined : json['landingImageLarge'],
        'timeRewardImage': json['timeRewardImage'] == null ? undefined : json['timeRewardImage'],
    };
}

export function CreateOverwolfGameImagesToJSON(json: any): CreateOverwolfGameImages {
    return CreateOverwolfGameImagesToJSONTyped(json, false);
}

export function CreateOverwolfGameImagesToJSONTyped(value?: CreateOverwolfGameImages | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logo': value['logo'],
        'icon': value['icon'],
        'devourGameLogo': value['devourGameLogo'],
        'thumbnailImage': value['thumbnailImage'],
        'bannerImageSmall': value['bannerImageSmall'],
        'bannerImageLarge': value['bannerImageLarge'],
        'landingImageSmall': value['landingImageSmall'],
        'landingImageLarge': value['landingImageLarge'],
        'timeRewardImage': value['timeRewardImage'],
    };
}

